import Card from 'react-bootstrap/Card';
import img1 from "../../../assets/images/equipoadministrativo.png";

function ImageAndTextExample() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 p-4"
      style={{
        backgroundImage: `url(${img1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}>

      <Card className="bg-white bg-opacity-75 shadow-lg border-0 rounded-4 mb-4 w-100" data-aos="fade-up">
        <Card.Body className="text-center p-4">
          <Card.Text className="fs-3 fw-bold">
              <h1 className="fw-bold text-mobile">
                ¡Gracias por tu interés!
              </h1>
              <p className="text-mobile">
                Queremos que quienes se sumen a nuestro equipo lo hagan con compromiso, profesionalismo y ganas de dejar huella.
              </p>
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="bg-white bg-opacity-75 shadow-lg border-0 rounded-4 mb-4 w-100" data-aos="fade-up">
        <Card.Body className="text-center p-4">
          <Card.Text className="fs-3 fw-bold mb-0">
              <p className="m-4 text-mobile">
                En el <strong>Colegio Santo Tomás</strong> valoramos a las personas que comparten nuestra visión y nuestros valores. 
                Nos entusiasma recibir a profesionales que quieran sumar su experiencia a nuestro proyecto educativo, con pasión y vocación.
              </p>
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="bg-white bg-opacity-75 shadow-lg border-0 rounded-4 w-100" data-aos="fade-up">
        <Card.Body className="text-center p-4">
          <Card.Text className="fs-5 ">
            <p className='text-mobile'>
              Promovemos un entorno de trabajo <span className="text-blue-900 font-medium">dinámico, colaborativo y respetuoso</span>, 
              donde cada integrante puede crecer y desarrollarse.
            </p>
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ImageAndTextExample;
